/* eslint-disable react-hooks/exhaustive-deps */
import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import moment from 'moment'
import {parseOrderReportData} from '../parsings'
import {useEffect, useMemo, useState} from 'react'
import {useLocation} from 'react-router-dom'

const useGetOrdersReport = () => {
  const Api = useApi()
  const location = useLocation()
  const view = new URLSearchParams(location?.search)?.get('view') || null

  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))
  const reportType = new URLSearchParams(location?.search)?.get('report_type') || null
  const customerGroupId = new URLSearchParams(location?.search)?.get('customer_group') || ''
  const salesRepEmail = new URLSearchParams(location?.search)?.get('sales_rep') || ''
  const customerId = new URLSearchParams(location?.search)?.get('customer_id') || null
  const customerType = new URLSearchParams(location?.search)?.get('customer_type') || null
  const supplierName = new URLSearchParams(location?.search)?.get('supplier_name') || null
  const classification = new URLSearchParams(location?.search)?.get('classification') || null
  const purchaserName = new URLSearchParams(location?.search)?.get('purchaser_name') || null
  const productId = new URLSearchParams(location?.search)?.get('product_id') || null
  const repType = new URLSearchParams(location?.search)?.get('rep_type') || null
  const brandId = new URLSearchParams(location?.search)?.get('brand') || null
  const couponCode = new URLSearchParams(location?.search)?.get('coupon_code') || null
  const couponCodeType = new URLSearchParams(location?.search)?.get('coupon_code_type') || null
  const profitPercentage = new URLSearchParams(location?.search)?.get('profit_percentage') || ''
  const isProfitable = new URLSearchParams(location?.search)?.get('is_profitable') || null

  const initialFilters = {
    sort_by: 'total_profit/-1',
    page: 1,
    limit: 30,
    search: '',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'),
    report_type: reportType || '',
    customer_group_id: customerGroupId,
    sales_rep_email: salesRepEmail,
    customer_id: customerId,
    customer_type: customerType,
    supplier_name: supplierName,
    classification: classification,
    purchaser_name: purchaserName,
    product_id: productId,
    rep_type: repType,
    brand_id: brandId,
    coupon_code: couponCode,
    coupon_code_type: couponCodeType,
    profit_percentage: profitPercentage,
    is_profitable: isProfitable,
  }

  const {filters, onSearch, onSortingChange, onDateChange, setMultipleFilters, onPageChange} =
    useFilters(initialFilters, {
      sortType: 'number',
    })

  const {
    data: response,
    isFetching,
    refetch,
  } = Api.useGetQuery('/analytics/profitability/orders', {
    filters: filters,
  })

  useEffect(() => {
    if (view === 'order-report') {
      refetch()
    }
  }, [filters])

  const onChangeSalesRepFilter = (values: any[]) => {
    setMultipleFilters({
      sales_rep_email: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
    // remove customer_group search param from url
    const url = new URL(window?.location?.href)
    url?.searchParams?.delete('sales_rep')
    window?.history?.replaceState({}, '', url?.toString())
  }

  const onChangeCustomerGroupFilter = (values: any[]) => {
    setMultipleFilters({
      customer_group_id: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
    // remove customer_group search param from url
    const url = new URL(window?.location?.href)
    url?.searchParams?.delete('customer_group')
    window?.history?.replaceState({}, '', url?.toString())
  }

  const onDownloadCSV = async () => {
    const {page, limit, ...restFilters} = filters
    const response: any = await Api.get('/analytics/profitability/orders/csv', {
      filters: restFilters,
    })
    return {
      message: response?.data?.message,
      status: response?.status,
    }
  }

  const onProfitPercentageChange = (value: string) => {
    setMultipleFilters({
      profit_percentage: value,
      page: 1,
    })
  }

  const onResetFilters = () => {
    setMultipleFilters({
      report_type: '',
      customer_group_id: '',
      sales_rep_email: '',
      customer_id: null,
      customer_type: null,
      supplier_name: null,
      classification: null,
      purchaser_name: null,
      product_id: null,
      rep_type: null,
      brand_id: null,
      coupon_code: null,
      coupon_code_type: null,
      profit_percentage: '',
      is_profitable: null,
    })
    // remove all search param from url except view
    const url = new URL(window?.location?.href)
    const paramsToDelete = Array.from(url.searchParams.keys()).filter((key) => key !== 'view')
    paramsToDelete.forEach((key) => url.searchParams.delete(key))
    window?.history?.replaceState({}, '', url?.toString())
  }

  const hasFilterApplied = useMemo(() => {
    return (
      filters?.customer_group_id ||
      filters?.sales_rep_email ||
      filters?.report_type ||
      filters?.customer_id ||
      filters?.customer_type ||
      filters?.supplier_name ||
      filters?.classification ||
      filters?.purchaser_name ||
      filters?.product_id ||
      filters?.rep_type ||
      filters?.brand_id ||
      filters?.coupon_code ||
      filters?.coupon_code_type ||
      filters?.profit_percentage ||
      filters?.is_profitable
    )
  }, [filters])

  return {
    ordersReportData: parseOrderReportData(response?.data || []),
    pagination: response?.meta?.pagination,
    orderCount: response?.meta?.pagination?.total || response?.data?.length,
    isOrdersReportLoading: isFetching,
    filters,
    hasOrderFilterApplied: hasFilterApplied,
    onSearch,
    onDateChange,
    onPageChange,
    onSortingChange,
    onChangeSalesRepFilter,
    onChangeCustomerGroupFilter,
    onDownloadCSV,
    onProfitPercentageChange,
    onResetFilters,
  }
}

export default useGetOrdersReport
